import { render } from "./todayTestList.vue?vue&type=template&id=0b60b91a&scoped=true"
import script from "./todayTestList.vue?vue&type=script&lang=js"
export * from "./todayTestList.vue?vue&type=script&lang=js"

import "./todayTestList.vue?vue&type=style&index=0&id=0b60b91a&lang=scss&scoped=true"

import exportComponent from "D:\\project\\digital-signage-cockpit-40\\防疫数据驾驶舱4.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b60b91a"]])

export default __exports__